import { IRestAudioCaption, IRestProviderCaptions } from '../../../../../../common/rest/audio/audioRest';
import { TConferenceCompareProgress } from '../../../../../../common/rest/conference/conferenceRest';
import { IAlignedRow } from './types';

// A compare-progress snapshot → progress-modal log line.
export const compareProgressMessage = (p: TConferenceCompareProgress): string =>
	p.phase === 'DONE' ? 'Done'
		: p.phase === 'FAILED' ? 'Failed'
			: `Transcribing… (${p.completed}/${p.total})${p.current ? ' · ' + p.current : ''}`;

// Two captions whose startTimes are within this many seconds share an aligned row.
// Kept ~1s (the display floors times to whole seconds) so provider timing jitter and differing
// segmentation still land same-second captions on one row, instead of drifting onto the next anchor.
export const ALIGN_TIME_TOLERANCE = .9;

// Aligns captions across provider sets by start time so equal-time captions sit on the same row.
// A new row is started when a caption falls outside the tolerance window of the current anchor,
// or when the current row's cell for that group is already taken.
export function buildAlignedRows(groups: IRestProviderCaptions[]): IAlignedRow[] {
	const entries: { time: number; gi: number; caption: IRestAudioCaption }[] = [];
	groups.forEach((g, gi) => {
		g.captions.forEach(caption => entries.push({ time: caption.startTime, gi, caption }));
	});
	entries.sort((a, b) => a.time - b.time);

	const rows: IAlignedRow[] = [];
	let current: IAlignedRow | null = null;
	let anchorTime = -Infinity;

	for (const e of entries) {
		if (!current || e.time - anchorTime > ALIGN_TIME_TOLERANCE || current.cells[e.gi]) {
			current = { time: e.time, cells: new Array(groups.length).fill(null) };
			rows.push(current);
			anchorTime = e.time;
		}
		current.cells[e.gi] = e.caption;
	}
	return rows;
}
